module.exports = __webpack_public_path__ + "assets/media/user-member-lovel02.19e5e334.png";